export default "__VITE_PUBLIC_ASSET__2c6192b0__"